import { render, staticRenderFns } from "./input-date.vue?vue&type=template&id=122b7f87&scoped=true"
import script from "./input-date.vue?vue&type=script&lang=js"
export * from "./input-date.vue?vue&type=script&lang=js"
import style0 from "./input-date.vue?vue&type=style&index=0&id=122b7f87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122b7f87",
  null
  
)

export default component.exports